import { RegisterNewForm } from "../../components/RegisterNewForm/RegisterNewForm";
import { useRegisterNewPage } from "./useRegisterNewPage";
import { PageWrapper } from "../../../../shared/components/layout/PageWrapper";

/**
 * RegisterNewPage
 * Page component for registering new news (novedades).
 * Can be used with or without a swimmer association.
 */
export const RegisterNewPage: React.FC = () => {
  const {
    reportTypes,
    maintenanceTypes,
    handleFormSubmit,
    handleNavigateToDashboard,
    isSubmitting,
    isLoadingSwimmer,
    isErrorSwimmer,
    swimmer,
    interventionLevels,
    poolRegulationTypes,
    adverseEventTypes,
  } = useRegisterNewPage();

  return (
    <PageWrapper
      isLoading={isLoadingSwimmer}
      loadingLabel="Cargando información del bañista..."
      isError={isErrorSwimmer}
      errorMessage="Error al cargar la información del bañista. Por favor, intente nuevamente."
      onBack={handleNavigateToDashboard}
      title="Registrar Novedad"
    >
      <RegisterNewForm
        onSubmit={handleFormSubmit}
        reportTypes={reportTypes}
        maintenanceTypes={maintenanceTypes}
        poolRegulations={poolRegulationTypes}
        interventionLevels={interventionLevels}
        adverseEventTypes={adverseEventTypes}
        isSubmitting={isSubmitting}
        swimmer={swimmer}
      />
    </PageWrapper>
  );
};
